import * as React from "react";

const SvgIcnInfoBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="none" strokeWidth={1} fill="currentColor" fillRule="evenodd">
            <circle cx={12} cy={6} r={2} />
            <rect x={10} y={10} width={4} height={10} rx={2} />
        </g>
    </svg>
);

export default SvgIcnInfoBold;
